var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.310547,
    width: 30,
    height: 30,
    fill: "url(#pattern0_112_619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_112_619",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_112_619",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_112_619",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpUlEQVR4nO3boW8UQRTH8YMSQtJAIEGQYBAYDAqDQoECQXHgkEgMovwBFU0wGFISSJAocCgwGDAYDAaBQJA2ISkESNtvM8nWNPRmbm7mzZu730c1uW735pfd2Tdvp6ORiIiIiIiIiIiIiIiIFAScBN4jMR+B09OGvQi8iZ5qfr0Fjpe6so8CL1uPyKHXwLGcQA+N+WwBeNZ6ZI48B47kZBk+fBE7GFhtPUIHHgOHIxfl03FBJ90OwAPm10rqNBsLOmmCB+4B28yPHeD+JIVDStBJJQtwB/jH7NsC7kayOLW/FE4NOvgMnI2c4Drwm9n1F7gVyeAM8Gn/gZMEHXwFzkdOdAX4yezZBK5Fxn4O+PK/gycNOvgOXIyc8BLwg9mxAVyOjPkC8O2gP5ATdJETd6TIhZUb9N6tdDX3VupEsalymqCDP7kPhw6kPPxvpD78pw06u9xxrng5WyLorALesSoLtFJBT7wkdapay6F00MlNFvyp2kSrEXT1L11B9YujVtA9df5WLKa7mkF77/ztWD7AawcdfHDY+duyLkktgi5e/LfqwPUQtJfO3+Y0Hbhegm7d+dto2QizDrrVgJu3dlsEbd358zBlNQvaqvPn5vVby6Brl1kpHbjbVmVl66BrLRzcLZQ8BF16Kexy6e8p6OBRwp6/NQ62ltDMCudg3oNm2Dy5ELkil4B3wK+hgglTxc3IMU03ZnoMOniVtQXW8QsHr0EX29Tt5RWa56CTOn+9/DuI96AZVodjl89jlvFhweJCD0EzPPSWU6YS4ATw0Ntmy16C3rMOPAkVRuhfDPPv4vDz0vBZ+B13egu6WwraiII2oqCNKGgjCtqIgjaioI0oaCMK2oiCNqKgjShoIwraiIJuHbSIiIiIiIiIiIiIiIiM4nYB1osmEtOFz7kAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeActive);
export default __webpack_public_path__ + "static/media/Envelope-active.294245637b56df2ca5d1415e69ade0c8.svg";
export { ForwardRef as ReactComponent };